var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VbDemo',[_c('VbCard',{attrs:{"title":"Default"}},[_c('square-with-icon',{attrs:{"iconClass":"ion ion-md-checkmark"}}),_c('square-with-icon',{attrs:{"iconClass":"ion ion-md-checkmark","color":"danger"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }